var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.threshold > 1 ? _c('div', [_c('div', {
    staticClass: "utxo_label"
  }, [_vm._v("Multi-Sig")]), _c('div', [_vm._v(" " + _vm._s(_vm.threshold) + " signatures out of " + _vm._s(_vm.addresses.length) + " addresses required to issue transaction ")])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }